import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useTranslation } from 'react-i18next';

import privacyPolicy from './privacy-policy';
import termOfService from './term-of-service';

type LegalFile = 'termOfService' | 'privacyPolicy';

interface RenderMarkdownProps {
  fileName: LegalFile;
}

export function RenderMarkdown(props: Readonly<RenderMarkdownProps>) {
  const { fileName } = props;
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const files = {
    privacyPolicy: privacyPolicy[currentLang as keyof typeof privacyPolicy],
    termOfService: termOfService[currentLang as keyof typeof termOfService],
  };

  const content = files[fileName];

  if (!content) {
    return (
      <Typography variant="body1">
        Content not found for "{fileName}" in [{currentLang}] language
      </Typography>
    );
  }

  return (
    <Markdown
      remarkPlugins={[remarkGfm]}
      components={{
        h3: ({ node, ...props }) => <Typography variant="h6" gutterBottom {...props} />,
        p: ({ node, ...props }) => <Typography variant="body2" gutterBottom {...props} />,
        li: ({ node, ...props }) => <Typography variant="body2" gutterBottom component="li" {...props} />,
        hr: () => <Divider sx={{ my: 2 }} />,
        blockquote: ({ node, ...props }) => (
          <Alert icon={false} severity="info" sx={{ mb: 2 }}>
            {props.children}
          </Alert>
        ),
      }}
    >
      {content}
    </Markdown>
  );
}
